export default "/_next/static/images/advertGames-e712b8a035cc385a31269aa9e275984b.png";